import {
  FETCH_BRANDS_REQUEST,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
  FETCH_BRAND_REQUEST,
  FETCH_BRAND_SUCCESS,
  FETCH_BRAND_FAILURE,
  UPDATE_BRANDS_REQUEST,
  UPDATE_BRANDS_FAILURE,
  UPDATE_BRANDS_SUCCESS,
  DELETE_BRANDS_REQUEST,
  DELETE_BRANDS_FAILURE,
  DELETE_BRANDS_SUCCESS,
  CLEAR_BRAND_ERRORS,    // Nouvelles imports
  CLEAR_BRAND_SUCCESS,
} from './actionTypes';

const initialState = {
  brands: [],
  brand: null,
  loadingBrand: false,
  errorBrand: null,
  brandAdded: null
};

const Brands = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRANDS_REQUEST:
      return {
        ...state,
        loadingBrand: true,
        errorBrand: null,
        brandAdded: false
      };
    case FETCH_BRANDS_SUCCESS:
      return {
        ...state,
        loadingBrand: false,
        brands: action.payload,
      };
    case FETCH_BRANDS_FAILURE:
      return {
        ...state,
        loadingBrand: false,
        errorBrand: action.payload,
      };
    case FETCH_BRAND_REQUEST:
      return {
        ...state,
        loadingBrand: true,
        errorBrand: null,
        brandAdded: false
      };
    case FETCH_BRAND_SUCCESS:
      return {
        ...state,
        loadingBrand: false,
        brand: action.payload,
      };
    case FETCH_BRAND_FAILURE:
      return {
        ...state,
        loadingBrand: false,
        errorBrand: action.payload,
      };
    case UPDATE_BRANDS_REQUEST:
      return {
        ...state,
        loadingBrand: true,
        errorBrand: null,
        brandAdded: false
      };
    case UPDATE_BRANDS_SUCCESS:
      return {
        ...state,
        loadingBrand: false,
        brand: null,
        brandAdded: true
      };
    case UPDATE_BRANDS_FAILURE:
      return {
        ...state,
        loadingBrand: false,
        errorBrand: action.payload,
      };
    case DELETE_BRANDS_REQUEST:
      return {
        ...state,
        loadingBrand: true,
        errorBrand: null,
        brandAdded: false
      };
    case DELETE_BRANDS_SUCCESS:
      return {
        ...state,
        brandAdded: true,
        loadingBrand: false,
        brands: state.brands.filter(brand => brand.id !== action.payload),
      };
    case DELETE_BRANDS_FAILURE:
      return {
        ...state,
        loadingBrand: false,
        errorBrand: action.payload,
      };
    case CLEAR_BRAND_ERRORS:
      return {
        ...state,
        errorBrand: null,
      };
    case CLEAR_BRAND_SUCCESS:
      return {
        ...state,
        brandAdded: null,
      };
      
    default:
      return state;
  }
};

export default Brands;